import React, { useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';



function ModalPage({modal, toggle, Comp}){
    
    
    const mheight = {
        minHeight: '60vh'
    }

    return (
 

        <Modal isOpen={modal} toggle={toggle}>

        
            <ModalHeader toggle={toggle} className="text-center" id="writeTitle">

            </ModalHeader>
        
            <ModalBody className="" style={mheight}>
                <Comp />
            </ModalBody>
 
       </Modal>


        
    )
}

export default ModalPage